import React from 'react';
import type { PropsWithChildren } from 'react';

import '@reckon-web/gql-api-client';
import { GqlApiClientProvider } from '@reckon-web/gql-api-client';

import { Config } from '../Config';
import { result as introspectionQueryResultData } from '../../../__generated__/ts-gql/@introspection';
import { refreshAuthTokenMutation } from '../Auth/refreshAuthTokenMutation';

export const PortalApolloProvider = ({ children }: PropsWithChildren<{}>) => {
  return (
    <GqlApiClientProvider
      name={Config.APPLICATION_APOLLO_CLIENT_NAME}
      operationPrefixNameForAddingToRawLogOutputs={
        Config.APPLICATION_APOLLO_CLIENT_OPERATIONPREFIX_SHORTNAME
      }
      schema={introspectionQueryResultData}
      url={Config.APPLICATION_APOLLO_CLIENT_API_URL}
      version={Config.APPLICATION_VERSION}
      onTokenRefresh={refreshAuthTokenMutation}
    >
      {children}
    </GqlApiClientProvider>
  );
};
